import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function PainSection() {
  return <section className="w-full bg-ink-950 py-16 sm:py-20" aria-labelledby="dolor-title" data-id="element-114" data-mp="38vkg8guarrwb">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-115" data-mp="2yzqwace90w4i">
        <h2 id="dolor-title" className="max-w-2xl font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-116" data-mp="2yy60ykk4195l">
          La realidad es dura. Tener un auto en 2026 es un{' '}
          <span className="text-alert" data-id="element-117" data-mp="2q15i0tft839j">desafío financiero</span>
        </h2>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-118" data-mp="2bbr89k8bnjtm">
          {painPoints.map((point, index) => <motion.li key={point.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: index * 0.07
        }} className="rounded-xl border border-white/10 bg-ink-900 p-6" data-id="element-119" data-mp="2g9ixu7lhutun" data-mpi={index}>
              <span className="mb-4 flex h-9 w-9 items-center justify-center rounded-md bg-alert/15 text-alert" data-id="element-120" data-mp="3nm74yo6vj9cp">
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-121" data-mp="5ehqcyagi7rf" />
              </span>
              <h3 className="font-display text-xl font-bold uppercase text-white" data-id="element-122" data-mp="gg8ggoroehj">
                {point.title}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-white/60" data-id="element-123" data-mp="38x2phergrj8a">
                {point.text}
              </p>
            </motion.li>)}
        </ul>

        <p className="mt-10 text-center font-display text-2xl font-bold uppercase leading-tight text-amber-brand sm:text-3xl" data-id="element-124" data-mp="3ine2dqt4l2rb">
          Si seguís dependiendo 100% de la &ldquo;buena voluntad&rdquo; del
          mecánico, estás perdiendo plata todos los meses.
        </p>
      </div>
    </section>;
}